import {
  BatchModifyRestrictionsService,
  Field,
  Rule,
} from "@root/router/price/batch-modify-restrictions/batch-modify-restrictions.service";
import { HttpClient } from "@angular/common/http";
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  booleanAttribute,
  computed,
  input,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { PlatformType } from "@root/config";
import { NzMessageService } from "ng-zorro-antd/message";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs";
import { range } from "lodash";
import { RulesSettingsService } from "../../rules-settings/rules-settings.service";
import { TranslateService } from "@root/shared/service/translate.service";
import moment from "moment";

interface House {
  thirdparty_type: number;
  origin_house_id: string;
  [prop: string]: any;
}

// type ControlType = 'input' | 'select' | 'checkbox'

interface ControlCfg<T> {
  isGroup?: boolean;
  type?: string;
  name: T;
  label?: string;
  placeholder?: string;
  tooltip?: string;
  extra?: string;
  children?: ControlCfg<string>[];
  options?: () => Option[];
}

@Component({
  selector: "widget-rules-settings-form",
  templateUrl: "./rules-settings-form.component.html",
  styleUrls: ["./rules-settings-form.component.scss"],
})
export class WidgetRulesSettingsFormComponent implements OnInit, OnDestroy {
  @Input() mode: Field = "mixed";
  @Input() activated = false;
  // @Input() house: House;
  house = input<House>();
  @Input() dateRange: Array<string | Date> = [];
  @Output() onSave = new EventEmitter<boolean>();

  isBooking = computed(() => {
    return this.house()?.thirdparty_type === PlatformType.Booking;
  });
  isAirbnb = computed(() => {
    return this.house()?.thirdparty_type === PlatformType.Airbnb;
  });
  isAgoda = computed(() => {
    return this.house()?.thirdparty_type === PlatformType.Agoda;
  });
  isBookingsite = computed(() => {
    return this.house()?.thirdparty_type === PlatformType.Bookingsite;
  });
  isExpedia = computed(() => {
    return this.house()?.thirdparty_type === PlatformType.Expedia;
  });

  isHoufy = computed(() => {
    return this.house()?.thirdparty_type === PlatformType.Houfy;
  });

  isHouseType = computed(() => {
    return this.house()?.is_room_type;
  });

  // get isBooking() {
  //   return this.house?.thirdparty_type === PlatformType.Booking;
  // }

  // get isAgoda() {
  //   return this.house?.thirdparty_type === PlatformType.Agoda;
  // }

  // get isAirbnb() {
  //   return this.house?.thirdparty_type === PlatformType.Airbnb;
  // }

  // get isBookingsite() {
  //   return this.house?.thirdparty_type === PlatformType.Bookingsite;
  // }

  // get isHouseType() {
  //   return this.house?.is_room_type;
  // }

  optionsOfMARHours = [{ label: "Reset", value: null }, ...range(0, 24).map((i) => ({ label: `${i}`, value: i }))];
  airbnbRulesList = [];
  loading = false;

  @Input() form: UntypedFormGroup = this.fb.group({
    min_advance_reservation: this.fb.group({
      days: null,
      hours: null,
    }),
    max_advance_reservation: this.fb.group({
      days: null,
      hours: null,
    }),
    min_stay_through: null,
    max_stay_through: null,
    min_stay_on_arrival: null,
    max_stay_on_arrival: null,
    exact_stay_on_arrival: null,
    closed_on_arrival: null,
    closed_on_departure: null,
    rule_id: null,
  });

  //#region Mixed Control Config

  readonly mixedControlCfg: ControlCfg<Rule>[] = [
    {
      isGroup: false,
      type: "input",
      name: "min_stay_on_arrival",
      label: this.t.t("operate_sidebar-rules_settings_html_min_stay_on_arrival"),
      placeholder: this.t.t("operate_sidebar-rules_settings_html_min_stay_on_arrival"),
      tooltip: this.t.t("operate_sidebar-rules_settings_html_min_stay_on_arrival_tip"),
    },
    {
      isGroup: false,
      type: "input",
      name: "max_stay_on_arrival",
      label: this.t.t("operate_sidebar-rules_settings_html_max_stay_on_arrival"),
      placeholder: this.t.t("operate_sidebar-rules_settings_html_max_stay_on_arrival"),
      tooltip: this.t.t("operate_sidebar-rules_settings_html_max_stay_on_arrival_tip"),
    },
    {
      isGroup: false,
      type: "input",
      name: "min_stay_through",
      label: this.t.t("operate_sidebar-rules_settings_html_min_stay_through"),
      placeholder: this.t.t("operate_sidebar-rules_settings_html_min_stay_through"),
      tooltip: this.t.t("operate_sidebar-rules_settings_html_min_stay_through_tip"),
    },
    {
      isGroup: false,
      type: "input",
      name: "max_stay_through",
      label: this.t.t("operate_sidebar-rules_settings_html_max_stay_through"),
      placeholder: this.t.t("operate_sidebar-rules_settings_html_max_stay_through"),
      tooltip: this.t.t("operate_sidebar-rules_settings_html_max_stay_through_tip"),
    },
    {
      isGroup: false,
      type: "input",
      name: "exact_stay_on_arrival",
      label: this.t.t("operate_sidebar-rules_settings_html_extra_stay_on_arrival"),
      placeholder: this.t.t("operate_sidebar-rules_settings_html_extra_stay_on_arrival"),
      tooltip: this.t.t("operate_sidebar-rules_settings_html_extra_stay_on_arrival_tip"),
    },
    {
      isGroup: true,
      name: "min_advance_reservation",
      label: this.t.t("operate_sidebar-rules_settings_html_min_advance_reservation"),
      placeholder: null,
      tooltip: this.t.t("operate_sidebar-rules_settings_html_min_advance_reservation_tip"),
      children: [
        { type: "input", name: "days", placeholder: this.t.t("operate_sidebar-rules_settings_html_days") },
        {
          type: "select",
          name: "hours",
          placeholder: this.t.t("operate_sidebar-rules_settings_html_hours"),
          options: () => this.optionsOfMARHours,
        },
      ],
    },
    {
      isGroup: true,
      name: "max_advance_reservation",
      label: this.t.t("operate_sidebar-rules_settings_html_max_advance_reservation"),
      placeholder: null,
      tooltip: this.t.t("operate_sidebar-rules_settings_html_max_advance_reservation_tip"),
      children: [
        {
          type: "input",
          name: "days",
          placeholder: this.t.t("operate_sidebar-rules_settings_html_max_advance_reservation"),
        },
      ],
    },
    {
      isGroup: false,
      type: "checkbox",
      name: "closed_on_arrival",
      label: this.t.t("operate_sidebar-rules_settings_html_closed_on_arrival"),
      placeholder: null,
      tooltip: this.t.t("operate_sidebar-rules_settings_html_closed_on_arrival_tip"),
    },
    {
      isGroup: false,
      type: "checkbox",
      name: "closed_on_departure",
      label: this.t.t("operate_sidebar-rules_settings_html_closed_on_departure"),
      placeholder: null,
      tooltip: this.t.t("operate_sidebar-rules_settings_html_closed_on_departure_tip"),
    },
    {
      isGroup: false,
      type: "select",
      name: "rule_id",
      label: this.t.t("operate_sidebar-rules_settings_html_seasonal_rule_sets"),
      placeholder: this.t.t("operate_sidebar-rules_settings_html_seasonal_rule_sets"),
      tooltip: null,
      extra: this.t.t("operate_sidebar-rules_settings_html_seasonal_rule_sets_tip"),
      options: () => this.airbnbRulesList,
    },
  ];

  //#endregion

  get minStayThrough() {
    return this.form.get("min_stay_through");
  }
  get maxStayThrough() {
    return this.form.get("max_stay_through");
  }
  get minStayOnArrival() {
    return this.form.get("min_stay_on_arrival");
  }
  get maxStayOnArrival() {
    return this.form.get("max_stay_on_arrival");
  }
  get exactStayOnArrival() {
    return this.form.get("exact_stay_on_arrival");
  }
  get closedOnArrival() {
    return this.form.get("closed_on_arrival");
  }
  get closedOnDeparture() {
    return this.form.get("closed_on_departure");
  }
  get ruleId() {
    return this.form.get("rule_id");
  }

  get minARDays() {
    return this.form.get("min_advance_reservation.days");
  }
  get minARHours() {
    return this.form.get("min_advance_reservation.hours");
  }
  get maxARDays() {
    return this.form.get("max_advance_reservation.days");
  }
  get maxARHours() {
    return this.form.get("max_advance_reservation.hours");
  }

  destroy$ = new Subject();
  constructor(
    private http: HttpClient,
    private fb: UntypedFormBuilder,
    private msg: NzMessageService,
    private rsSrv: RulesSettingsService,
    private t: TranslateService,
    private bmrSrv: BatchModifyRestrictionsService,
  ) {}

  ngOnInit() {
    console.log("house: ", this.house(), "dateRange: ", this.dateRange);

    this.fetchDetail();

    this.rsSrv.onSave$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.requestUpdate();
    });

    this.disableFields();
  }

  private fetchDetail() {
    const params = {
      origin_house_id: this.house().origin_house_id,
      start_date: moment(this.dateRange?.[0]).format("YYYY-MM-DD"),
      end_date: moment(this.dateRange?.[1]).format("YYYY-MM-DD"),
      type: this.isHouseType() ? "house_type" : "house",
    };
    let request$;
    if (this.isBooking()) {
      request$ = this.fetchBookingDetail(params);
    } else if (this.isAgoda()) {
      request$ = this.fetchAgodaDetail(params);
    } else if (this.isBookingsite()) {
      request$ = this.fetchBookingsiteDetail(params);
    } else if (this.isExpedia()) {
      request$ = this.fetchExpediaDetail(params);
    } else if (this.isAirbnb()) {
      this.fetchAirbnbRules();
      request$ = this.fetchAirbnbDetail(params);
    } else if (this.isHoufy()) {
      request$ = this.fetchHoufyDetail(params);
    } else {
      request$ = this.fetchVrboDetail(params);
    }
    this.loading = true;
    request$.subscribe((rst: any) => {
      this.loading = false;
      if (rst.error_code === 0) {
        if (this.isAirbnb()) {
          this.form.patchValue({
            ...rst.data,
            rule_id: rst.data?.listing_rule?.id,
            closed_on_arrival: !!rst.data.closed_on_arrival,
            closed_on_departure: !!rst.data.closed_on_departure,
          });
          // this.disableAirbnbFields();
        } else {
          this.form.patchValue({
            ...rst.data,
            closed_on_arrival: !!rst.data.closed_on_arrival,
            closed_on_departure: !!rst.data.closed_on_departure,
          });
          if (this.isBooking()) {
            // this.disableBookingFields();

            if (!rst.data.min_stay_through) {
              this.form.patchValue({ min_stay_through: null });
            }
            if (!rst.data.min_stay_on_arrival) {
              this.form.patchValue({ min_stay_on_arrival: null });
            }
          }

          // if (this.isAgoda) {
          //   this.disableAgodaFields();
          // }

          // if (this.isBookingsite) {
          //   this.disableBookingsiteFields();
          // }
        }
      }

      console.log("form: ", this.form.value);
    });
  }

  private requestUpdate() {
    const form = this.form.value;
    const params = {
      origin_house_id: this.house().origin_house_id,
      start_date: moment(this.dateRange?.[0]).format("YYYY-MM-DD"),
      end_date: moment(this.dateRange?.[1]).format("YYYY-MM-DD"),
      type: this.isHouseType() ? "house_type" : "house",
      ...form,
      closed_on_arrival: form.closed_on_arrival & 1,
      closed_on_departure: form.closed_on_departure & 1,
    };

    this.onSave.emit(true);

    if (this.isBooking()) {
      this.requestUpdateBookingInfo(params);
    } else if (this.isAgoda()) {
      this.requestUpdateAgodaInfo(params);
    } else if (this.isBookingsite()) {
      this.requestUpdateBookingsiteInfo(params);
    } else if (this.isExpedia()) {
      this.requestUpdateExpediaInfo(params);
    } else if (this.isAirbnb()) {
      this.requestUpdateAirbnbInfo(params);
    } else if (this.isHoufy()) {
      this.requestUpdateHoufyInfo(params);
    } else {
      this.requestUpdateVrboInfo(params);
    }
  }

  private fetchBookingDetail(params) {
    return this.http.get("/api/docking/booking/get_settings", { params });
  }

  private fetchAirbnbDetail(params) {
    return this.http.get("/api/docking/airbnb/get_calendar", { params });
  }

  private fetchAgodaDetail(params) {
    return this.http.get("/api/docking/agoda/get_settings", { params });
  }

  private fetchBookingsiteDetail(params) {
    return this.http.get("/api/docking/bs/get_settings", { params });
  }

  private fetchExpediaDetail(params) {
    return this.http.get("/api/docking/expedia/get_restrictions", { params });
  }

  private fetchVrboDetail(params) {
    return this.http.get("/api/docking/vrbo/get_restrictions", { params });
  }

  private fetchHoufyDetail(params) {
    return this.http.get("/api/docking/houfy/get_restrictions", { params });
  }

  private fetchAirbnbRules() {
    const params = { thirdparty_account_id: this.house().thirdparty_account_id };
    this.http.get("/api/docking/airbnb/all_seasonal_rules", { params }).subscribe((rst: any) => {
      this.airbnbRulesList = rst?.data?.map((item) => ({
        // ...item,
        label: item.title,
        value: item.id,
      }));
      this.airbnbRulesList.unshift({ label: "None", value: null });
      console.log("rule list: ", this.airbnbRulesList);
    });
  }

  private requestUpdateBookingInfo(params) {
    this.http.post("/api/docking/booking/update_settings", params).subscribe((rst: any) => {
      this.onSave.emit(false);
      if (rst.error_code === 0) {
        this.msg.success(this.t.t("success.save"));
      }
    });
  }

  private requestUpdateBookingsiteInfo(params) {
    this.http.post("/api/docking/bs/update_settings", params).subscribe((rst: any) => {
      this.onSave.emit(false);
      if (rst.error_code === 0) {
        this.msg.success(this.t.t("success.save"));
      }
    });
  }

  private requestUpdateAgodaInfo(params) {
    this.http.post("/api/docking/agoda/update_settings", params).subscribe((rst: any) => {
      this.onSave.emit(false);
      if (rst.error_code === 0) {
        this.msg.success(this.t.t("success.save"));
      }
    });
  }

  private requestUpdateExpediaInfo(params) {
    this.http.post("/api/docking/expedia/set_restrictions", params).subscribe((rst: any) => {
      this.onSave.emit(false);
      if (rst.error_code === 0) {
        this.msg.success(this.t.t("success.save"));
      }
    });
  }

  private requestUpdateVrboInfo(params) {
    this.http.post("/api/docking/vrbo/set_restrictions", params).subscribe((rst: any) => {
      this.onSave.emit(false);
      if (rst.error_code === 0) {
        this.msg.success(this.t.t("success.save"));
      }
    });
  }

  private requestUpdateHoufyInfo(params) {
    this.http.post("/api/docking/houfy/set_restrictions", params).subscribe((rst: any) => {
      this.onSave.emit(false);
      if (rst.error_code === 0) {
        this.msg.success(this.t.t("success.save"));
      }
    });
  }

  private requestUpdateAirbnbInfo(params) {
    this.http.post("/api/docking/airbnb/set_operations", params).subscribe((rst: any) => {
      this.onSave.emit(false);
      if (rst.error_code === 0) {
        this.msg.success(this.t.t("success.save"));
      }
    });
  }

  isSupportRule(rule: Rule) {
    return this.bmrSrv.isPlatformSupportRule(this.house().thirdparty_type, rule);
  }

  private disableFields() {
    [
      "min_stay_on_arrival",
      "max_stay_on_arrival",
      "min_stay_through",
      "max_stay_through",
      "exact_stay_on_arrival",
      "min_advance_reservation",
      "max_advance_reservation",
      "closed_on_arrival",
      "closed_on_departure",
      "rule_id",
    ].forEach((rule: Rule) => {
      if (!this.isSupportRule(rule)) {
        if (rule === "min_advance_reservation" || rule === "max_advance_reservation") {
          this.form.get(rule + ".days").disable();
          this.form.get(rule + ".hours").disable();
        } else {
          this.form.get(rule).disable();
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
